export const chickenSkinMiddlewareForSkinEditor = (data) => {
  const {
    sportCarColor,
    busColor,
    pickupColor,
    truckColor,
    streetBarrierColor1,
    streetBarrierColor2,
    streetBarrierImage,
  } = data;
  return {
    ...data,
    autoParkConfigs: getAutoParkConfigsStringObj({ sportCarColor, busColor, pickupColor, truckColor }),
    streetBarrierConfigs: getStreetBarrierConfigsStringObj({
      streetBarrierColor1,
      streetBarrierColor2,
      streetBarrierImage,
    }),
  };
};

const getAutoParkConfigsStringObj = ({ sportCarColor, busColor, pickupColor, truckColor }) => {
  return `
  { 
  SportCar: [ ${sportCarColor ? `{count: 1, color: '${sportCarColor}'}` : "{count: 1, color: '#F22D47'}, {count: 1, color: '#39ed39'}"}], 
  Bus: [ ${busColor ? `{count: 1, color: '${busColor}'}` : "{count: 1, color: '#FEC03C'}, {count: 1, color: '#d13ce8'}"}], 
  Pickup: [ ${pickupColor ? `{count: 1, color: '${pickupColor}'}` : "{count: 1, color: '#4A73F1'}"}], 
  Truck: [ ${truckColor ? `{count: 1, color: '${truckColor}'}` : "{count: 1, color: '#4455A5'}"}], 
  AmbulanceCar: [ {count: 1} ], 
  PoliceCar: [ {count: 1} ], 
  Taxi: [ {count: 2} ], 
  }
  `;
};

const getStreetBarrierConfigsStringObj = ({ streetBarrierColor1, streetBarrierColor2, streetBarrierImage }) => {
  return `
  { color1: '${streetBarrierColor1 ? streetBarrierColor1 : "#F37520"}', color2: '${streetBarrierColor2 ? streetBarrierColor2 : "#FEF2D3"}', imageUrl: '${streetBarrierImage || false}'}
  `;
};
